// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".service-card[data-v-30607d5a] {\n  border: 1px solid #BED1DA;\n  border-radius: 10px;\n  width: 100%;\n}\n.service-card-header[data-v-30607d5a] {\n  position: relative;\n  background: #F4F4F8;\n}", ""]);
// Exports
module.exports = exports;
